/* Native Shopify identity. No credentials, email, customer ID or cart token in local storage. */
(() => {
  'use strict';
  if(window.VessariqAccount)return;
  const returnPath = () => {
    const url = new URL(location.href), keep = new URLSearchParams();
    ['variant','vq_hair','view','preview_theme_id'].forEach(k=>{if(url.searchParams.has(k))keep.set(k,url.searchParams.get(k));});
    return `${url.pathname}${keep.size ? `?${keep}` : ''}${url.hash}`;
  };
  function refresh() {
    const template=document.getElementById('VqCartAccountTemplate');
    document.querySelectorAll('.cart-drawer__summary').forEach(parent=>{
      if(template && !parent.querySelector('[data-vq-cart-account]'))parent.prepend(template.content.cloneNode(true));
    });
    document.querySelectorAll('[data-vq-storefront-signin]').forEach(link=>{
      const url=new URL(link.dataset.vqLoginBase || link.href,location.origin);
      if(url.origin===location.origin && url.pathname.endsWith('/customer_authentication/login')) {
        link.dataset.vqLoginBase ||= link.href;
        url.searchParams.set('return_to',returnPath()); link.href=url.href;
      }
    });
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest?.('[data-vq-storefront-signin]');
    if(!link || event.defaultPrevented || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target==='_blank')return;
    refresh();
    const wait=window.VessariqCartNavigation?.wait;
    if(typeof wait!=='function')return;
    event.preventDefault();
    const url=link.href;link.setAttribute('aria-busy','true');
    Promise.race([Promise.resolve().then(()=>wait.call(window.VessariqCartNavigation)),new Promise(resolve=>setTimeout(resolve,2000))]).catch(()=>{}).finally(()=>{link.removeAttribute('aria-busy');location.assign(url);});
  });
  document.addEventListener('click',e=>document.querySelectorAll('[data-vq-account-menu][open]').forEach(menu=>{if(!menu.contains(e.target))menu.open=false;}));
  document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('[data-vq-account-menu][open]').forEach(menu=>{menu.open=false;menu.querySelector('summary')?.focus();});});
  document.addEventListener('shopify:section:load',refresh);
  document.addEventListener('vq:cart-updated',refresh);
  addEventListener('pageshow',refresh);
  window.VessariqAccount={refresh};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
})();
